/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDISINVESTMENTTYPE } from './IAPDISINVESTMENTTYPE';
import {
    IAPDISINVESTMENTTYPEFromJSON,
    IAPDISINVESTMENTTYPEFromJSONTyped,
    IAPDISINVESTMENTTYPEToJSON,
} from './IAPDISINVESTMENTTYPE';
import type { ProposalSummaryRegularWithdrawalInstructionsBreakdown } from './ProposalSummaryRegularWithdrawalInstructionsBreakdown';
import {
    ProposalSummaryRegularWithdrawalInstructionsBreakdownFromJSON,
    ProposalSummaryRegularWithdrawalInstructionsBreakdownFromJSONTyped,
    ProposalSummaryRegularWithdrawalInstructionsBreakdownToJSON,
} from './ProposalSummaryRegularWithdrawalInstructionsBreakdown';

/**
 * 
 * @export
 * @interface ProposalSummaryRegularWithdrawalInstructions
 */
export interface ProposalSummaryRegularWithdrawalInstructions {
    /**
     * 
     * @type {IAPDISINVESTMENTTYPE}
     * @memberof ProposalSummaryRegularWithdrawalInstructions
     */
    regularWithdrawalType?: IAPDISINVESTMENTTYPE;
    /**
     * 
     * @type {Array<ProposalSummaryRegularWithdrawalInstructionsBreakdown>}
     * @memberof ProposalSummaryRegularWithdrawalInstructions
     */
    regularWithdrawalInstructionsBreakdown: Array<ProposalSummaryRegularWithdrawalInstructionsBreakdown>;
}

/**
 * Check if a given object implements the ProposalSummaryRegularWithdrawalInstructions interface.
 */
export function instanceOfProposalSummaryRegularWithdrawalInstructions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "regularWithdrawalInstructionsBreakdown" in value;

    return isInstance;
}

export function ProposalSummaryRegularWithdrawalInstructionsFromJSON(json: any): ProposalSummaryRegularWithdrawalInstructions {
    return ProposalSummaryRegularWithdrawalInstructionsFromJSONTyped(json, false);
}

export function ProposalSummaryRegularWithdrawalInstructionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryRegularWithdrawalInstructions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'regularWithdrawalType': !exists(json, 'RegularWithdrawalType') ? undefined : IAPDISINVESTMENTTYPEFromJSON(json['RegularWithdrawalType']),
        'regularWithdrawalInstructionsBreakdown': ((json['RegularWithdrawalInstructionsBreakdown'] as Array<any>).map(ProposalSummaryRegularWithdrawalInstructionsBreakdownFromJSON)),
    };
}

export function ProposalSummaryRegularWithdrawalInstructionsToJSON(value?: ProposalSummaryRegularWithdrawalInstructions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'RegularWithdrawalType': IAPDISINVESTMENTTYPEToJSON(value.regularWithdrawalType),
        'RegularWithdrawalInstructionsBreakdown': ((value.regularWithdrawalInstructionsBreakdown as Array<any>).map(ProposalSummaryRegularWithdrawalInstructionsBreakdownToJSON)),
    };
}

